/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * No Result
 */
export const METRIC_DAPI_NO_RESULT = 'DAPI_NoResult';
export const METRIC_DAPI_FILTER = 'DAPI_FilterProperty';
export const METRIC_DAPI_GETALLMODULES = 'DAPI_GetAllModules';
